import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import AssignMember from '@features/crm/brands/components/AssignMember';
import BrandClientList from '@features/crm/brands/components/nitex-operation-team/BrandClientList';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

const NitexOperationTeam = () => {
	const userTypeList = [
		{ title: 'Project Manager', value: 'PROJECT_MANAGER' },
		{ title: 'Account Manager', value: 'ACCOUNT_MANAGER' },
		{ title: 'Merchandiser', value: 'MERCHANDISER' },
		{ title: 'BDM', value: 'BUSINESS_DEVELOPMENT_MANAGER' },
		{ title: 'Fashion Designer', value: 'FASHION_DESIGNER' },
		{ title: 'Costing Engineer', value: 'COSTING_MANAGER' },
		{ title: 'QC Engineer', value: 'QA' },
		{ title: 'Garment Tech', value: 'GARMENTS_TECH' },
		{ title: 'PD', value: 'PRODUCT_DEVELOPMENT' }
	];
	const [teamMembers, setTeamMembers] = useState({});
	const [openModal, setOpenModal] = useState(false);
	const [selectedType, setSelectedType] = useState(null);
	const dispatch = useDispatch();
	const { id } = useParams();

	const fetchTeamMembers = async () => {
		try {
			dispatch(openLoader());
			const { data } = await ApiClient.GET(`${BASE_URL}/brand/${id}/members`, '', true);
			setTeamMembers(data);
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	useEffect(() => {
		fetchTeamMembers();
	}, [id]);

	const handleModal = (userType) => {
		setSelectedType(userType);
		setOpenModal(true);
	};

	const closeModal = () => {
		setSelectedType(null);
		setOpenModal(false);
	};

	const renderUserTypeWithAddButton = (title, userType) => {
		return (
			<div className="person-title d-flex justify-content-between">
				<p className="regular-14 gray_dark_01 designation">{title}</p>
				<span className="position-relative">
					<img
						src={`${process.env.PUBLIC_URL}/icons/add-people.svg`}
						alt="add"
						className="cursor-pointer"
						onClick={() => handleModal(userType)}
					/>

					{openModal && selectedType === userType && (
						<AssignMember
							callback={fetchTeamMembers}
							existingUsers={teamMembers[userType]}
							selectedType={selectedType}
							closeModal={closeModal}
							removeMember={removeMember}
						/>
					)}
				</span>
			</div>
		);
	};

	const removeMember = async (userId) => {
		try {
			dispatch(openLoader());
			await ApiClient.DELETE(`${BASE_URL}/brand/${id}/members/${userId}`, '', '', true);
			fetchTeamMembers();
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const renderUsers = (userType) => {
		return teamMembers[userType]?.map((user) => {
			return (
				<div key={`user_${user.id}`} className="person-info d-flex align-items-center">
					<div className="image">
						{user?.profilePicDocument?.docUrl ? (
							<img src={user?.profilePicDocument?.docUrl} alt="profile" />
						) : (
							<img src={`${process.env.PUBLIC_URL}/images/pro_pic_default.svg`} alt="profile" />
						)}
					</div>
					<div className="details-info">
						<div className="name">
							<p>{user.name}</p>
							<p className="email">{user.email}</p>
						</div>
					</div>
					<div>
						<img
							onClick={() => removeMember(user.id)}
							src={`${process.env.PUBLIC_URL}/icons/delete_gray.svg`}
							alt="delete"
							className="delete-icon cursor-pointer"
						/>
					</div>
				</div>
			);
		});
	};

	return (
		<div className="tab-contents">
			<div className="d-flex all-team">
				<div className="w-50 border-right-solid pr-4">
					<div className="create-order-container">
						<div className="team-conainer team-section">
							<div className="team-body">
								{userTypeList.slice(0, 4).map((item) => (
									<div
										key={`userType_${item.value}`}
										className="single-team-person multiperson d-flex"
									>
										{renderUserTypeWithAddButton(item.title, item.value)}
										<div className="person-details">{renderUsers(item.value)}</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
				<div className="w-50 pl-4">
					<div className="create-order-container">
						<div className="team-conainer team-section">
							<div className="team-body">
								{userTypeList.slice(4).map((item) => (
									<div
										key={`userType_${item.value}`}
										className="single-team-person multiperson d-flex"
									>
										{renderUserTypeWithAddButton(item.title, item.value)}
										<div className="person-details">{renderUsers(item.value)}</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
			<BrandClientList users={teamMembers} />
		</div>
	);
};

export default NitexOperationTeam;
